import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DollarSign, TrendingUp, FileText, CreditCard, AlertCircle, CheckCircle, Download, Plus, ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
export function FinanceDashboard() {
  const navigate = useNavigate();
  const stats = [{
    label: 'Pendapatan Bulanan',
    value: 'Rp 50 Juta',
    trend: '+8% dari bulan lalu',
    icon: DollarSign,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Pembayaran Tertunda',
    value: 'Rp 12 Juta',
    trend: '45 invoice',
    icon: AlertCircle,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Selesai Bulan Ini',
    value: 'Rp 38 Juta',
    trend: '156 transaksi',
    icon: CheckCircle,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Tingkat Penagihan',
    value: '92%',
    trend: '+3% peningkatan',
    icon: TrendingUp,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }];
  const recentTransactions = [{
    id: 'INV-2025-001234',
    member: 'John Doe',
    amount: 'Rp 500.000',
    date: '10 Jan 2025',
    status: 'completed'
  }, {
    id: 'INV-2025-001233',
    member: 'Jane Smith',
    amount: 'Rp 500.000',
    date: '9 Jan 2025',
    status: 'completed'
  }, {
    id: 'INV-2025-001232',
    member: 'PT Tech Indo',
    amount: 'Rp 5.000.000',
    date: '8 Jan 2025',
    status: 'pending'
  }];
  const overdueInvoices = [{
    id: 'INV-2024-001230',
    member: 'Ahmad Rizki',
    amount: 'Rp 500.000',
    dueDate: '31 Des 2024',
    daysOverdue: 10
  }, {
    id: 'INV-2024-001229',
    member: 'Siti Rahayu',
    amount: 'Rp 250.000',
    dueDate: '28 Des 2024',
    daysOverdue: 13
  }];
  const handleSendReminder = (invoiceId: string) => {
    alert(`Mengirim pengingat untuk invoice ${invoiceId}`);
  };
  return <div className="min-h-screen bg-white" data-id="element-3032">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-3033">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-3034">
          <div data-id="element-3035">
            <div className="flex items-center gap-2 sm:gap-3 mb-2" data-id="element-3036">
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-neutral-900" data-id="element-3037">
                Dasbor Keuangan
              </h1>
              <Badge className="bg-warning text-white font-semibold text-xs" data-id="element-3038">
                BENDAHARA
              </Badge>
            </div>
            <p className="text-sm sm:text-base text-neutral-600" data-id="element-3039">
              Kelola pembayaran, invoice, dan laporan keuangan
            </p>
          </div>
          <div className="flex gap-2 sm:gap-3" data-id="element-3040">
            <Button variant="secondary" size="sm" onClick={() => navigate('/finance/reports')} className="flex-1 sm:flex-none" data-id="element-3041">
              <Download className="w-4 h-4 sm:mr-2" data-id="element-3042" />
              <span className="hidden sm:inline" data-id="element-3043">Export Laporan</span>
              <span className="sm:hidden" data-id="element-3044">Export</span>
            </Button>
            <Button size="sm" onClick={() => navigate('/finance/invoices/create')} className="flex-1 sm:flex-none" data-id="element-3045">
              <Plus className="w-4 h-4 sm:mr-2" data-id="element-3046" />
              <span className="hidden sm:inline" data-id="element-3047">Buat Invoice</span>
              <span className="sm:hidden" data-id="element-3048">Buat</span>
            </Button>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-3049">
          {stats.map((stat, i) => <Card key={i} data-id="element-3050">
              <CardContent className="p-4 sm:p-6" data-id="element-3051">
                <div className="flex justify-between items-start mb-3 sm:mb-4" data-id="element-3052">
                  <div className={`p-2 sm:p-3 rounded-lg ${stat.bgColor}`} data-id="element-3053">
                    <stat.icon className={`w-5 h-5 sm:w-6 sm:h-6 ${stat.color}`} data-id="element-3054" />
                  </div>
                  <TrendingUp className="w-4 h-4 text-success" data-id="element-3055" />
                </div>
                <div className="space-y-1" data-id="element-3056">
                  <h3 className="text-xl sm:text-2xl font-semibold text-neutral-900" data-id="element-3057">
                    {stat.value}
                  </h3>
                  <p className="text-xs sm:text-sm text-neutral-600" data-id="element-3058">
                    {stat.label}
                  </p>
                </div>
                <p className="text-xs mt-2 sm:mt-3 text-neutral-500" data-id="element-3059">
                  {stat.trend}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8" data-id="element-3060">
          {/* Recent Transactions */}
          <Card data-id="element-3061">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-3062">
              <CardTitle className="text-base sm:text-lg" data-id="element-3063">
                Transaksi Terbaru
              </CardTitle>
              <Button variant="link" className="text-atios-primary text-sm" onClick={() => navigate('/finance/transactions')} data-id="element-3064">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-3065">
              <div className="overflow-x-auto -mx-4 sm:mx-0" data-id="element-3066">
                <div className="inline-block min-w-full align-middle" data-id="element-3067">
                  <Table data-id="element-3068">
                    <TableHeader data-id="element-3069">
                      <TableRow data-id="element-3070">
                        <TableHead className="text-xs sm:text-sm" data-id="element-3071">
                          Invoice
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-3072">
                          Anggota
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-3073">
                          Jumlah
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-3074">
                          Status
                        </TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody data-id="element-3075">
                      {recentTransactions.map(tx => <TableRow key={tx.id} data-id="element-3076">
                          <TableCell className="font-medium text-atios-primary text-xs sm:text-sm" data-id="element-3077">
                            {tx.id}
                          </TableCell>
                          <TableCell data-id="element-3078">
                            <div data-id="element-3079">
                              <p className="font-medium text-xs sm:text-sm text-neutral-900" data-id="element-3080">
                                {tx.member}
                              </p>
                              <p className="text-xs text-neutral-500" data-id="element-3081">
                                {tx.date}
                              </p>
                            </div>
                          </TableCell>
                          <TableCell className="font-medium text-xs sm:text-sm text-neutral-900" data-id="element-3082">
                            {tx.amount}
                          </TableCell>
                          <TableCell data-id="element-3083">
                            <Badge variant={tx.status === 'completed' ? 'success' : 'warning'} className="text-xs" data-id="element-3084">
                              {tx.status === 'completed' ? 'LUNAS' : 'TERTUNDA'}
                            </Badge>
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Overdue Invoices */}
          <Card data-id="element-3085">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-3086">
              <CardTitle className="text-base sm:text-lg" data-id="element-3087">
                Invoice Jatuh Tempo
              </CardTitle>
              <Button variant="link" className="text-error text-sm" onClick={() => navigate('/finance/invoices?status=overdue')} data-id="element-3088">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-3089">
              <div className="space-y-3 sm:space-y-4" data-id="element-3090">
                {overdueInvoices.map(invoice => <div key={invoice.id} className="p-3 sm:p-4 rounded-lg border border-error-light bg-error-light/50 hover:border-error transition-all" data-id="element-3091">
                    <div className="flex items-start justify-between gap-2 mb-2" data-id="element-3092">
                      <div className="flex-1" data-id="element-3093">
                        <p className="font-medium text-sm sm:text-base text-neutral-900" data-id="element-3094">
                          {invoice.id}
                        </p>
                        <p className="text-xs sm:text-sm text-neutral-600" data-id="element-3095">
                          {invoice.member}
                        </p>
                      </div>
                      <Badge variant="error" className="text-xs flex-shrink-0" data-id="element-3096">
                        {invoice.daysOverdue} hari
                      </Badge>
                    </div>
                    <div className="flex items-center justify-between mt-3" data-id="element-3097">
                      <span className="text-base sm:text-lg font-semibold text-neutral-900" data-id="element-3098">
                        {invoice.amount}
                      </span>
                      <Button size="sm" variant="secondary" onClick={() => handleSendReminder(invoice.id)} className="text-xs" data-id="element-3099">
                        Kirim Pengingat
                      </Button>
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Quick Actions */}
        <div data-id="element-3100">
          <h2 className="text-base sm:text-lg font-semibold text-neutral-900 mb-4" data-id="element-3101">
            Aksi Cepat
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4" data-id="element-3102">
            {[{
            label: 'Buat Invoice',
            icon: Plus,
            onClick: () => navigate('/finance/invoices/create')
          }, {
            label: 'Rekam Pembayaran',
            icon: CreditCard,
            onClick: () => navigate('/finance/payments')
          }, {
            label: 'Laporan Keuangan',
            icon: FileText,
            onClick: () => navigate('/finance/reports')
          }, {
            label: 'Export Data',
            icon: Download,
            onClick: () => navigate('/finance/export')
          }].map((action, i) => <Button key={i} variant="secondary" className="h-auto py-3 sm:py-4 flex flex-col gap-2 hover:border-atios-primary transition-all" onClick={action.onClick} data-id="element-3103">
                <action.icon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-3104" />
                <span className="text-xs sm:text-sm text-center" data-id="element-3105">
                  {action.label}
                </span>
              </Button>)}
          </div>
        </div>
      </div>
    </div>;
}